import GradeIcon from "@mui/icons-material/Grade";
import { Box, Typography as MuiTypography, SxProps } from "@mui/material";

import { theme } from "../../mui-customs/Theme";

interface RatingDisplayProps {
  value?: number;
  sx?: SxProps;
}
const RatingDisplay = ({ value, sx }: RatingDisplayProps) => {
  return (
    <Box
      sx={{
        background: theme.brand1[500],
        p: " 6px 8px",
        borderRadius: "5px",
        display: "flex",
        alignItems: "center",
        gap: "4px",
        width: "fit-content",
        ...sx,
      }}
    >
      <GradeIcon
        sx={{ color: theme.whiteBg.WBG1, height: "18px", width: "18px" }}
      />
      <MuiTypography
        sx={{
          fontFamily: "Poppins",
          fontSize: "16px",
          lineHeight: "20px",
          fontWeight: "400",
          color: theme.whiteBg.WBG1,
        }}
      >
        {value ? (value % 1 !== 0 ? value.toFixed(2) : value) : 0}
      </MuiTypography>
    </Box>
  );
};

export default RatingDisplay;
